import type { PlatformWritePort, TrackingContext } from '../core/types';

export function createPlatformCommandService(writePort: PlatformWritePort) {
  return {
    upsertPlatformSetting: (key: string, value: string, tracking?: TrackingContext) =>
      writePort.upsertPlatformSetting(key, value, tracking),
  };
}
